import React, { useEffect, useState, useRef } from 'react';
import './EventNotification.css';
import { Shuffle, EyeOff, Eye, Flame } from 'lucide-react'; 

function EventNotification({ eventType, isSecondary }) {
    const [displayType, setDisplayType] = useState(null);
    const [isExiting, setIsExiting] = useState(false);
    const timerRef = useRef(null);

    useEffect(() => {
        if (eventType) {
            if (timerRef.current) clearTimeout(timerRef.current);
            setDisplayType(eventType);
            setIsExiting(false);
            
            // Start exit animation after 2.5 seconds
            timerRef.current = setTimeout(() => {
                setIsExiting(true);
            }, 2500);
        }
    }, [eventType]);

    const handleAnimationEnd = () => {
        if (isExiting) {
            setDisplayType(null);
            setIsExiting(false);
        }
    };

    if (!displayType) return null;

    let title = "EVENT";
    let desc = "WARNING!";
    let Icon = Shuffle;
    let className = "";
    
    // --- Random Events ---
    if (displayType === 'inverted') {
        title = "CHAOS MODE";
        desc = "CONTROLS INVERTED!";
        Icon = Shuffle;
        className = "inverted";
    } else if (displayType === 'blackout') {
        title = "BLACKOUT";
        desc = "LIGHTS OUT!";
        Icon = EyeOff;
        className = "blackout";
    } else if (displayType === 'hidden_walls') {
        title = "MEMORY TEST";
        desc = "HIDDEN WALLS!";
        Icon = Eye;
        className = "hidden-walls";
    } else if (displayType === 'lava_floor') {
        title = "THE FLOOR IS LAVA";
        desc = "DONT TOUCH WALLS!";
        Icon = Flame;
        className = "lava-floor";
    }

    // REMOVED: Power Up: Ghost block

    return (
        <div className={`event-notification ${isSecondary ? 'secondary' : ''}`}>
            <div 
                className={`event-content ${className} ${isExiting ? 'fade-out' : ''}`}
                onAnimationEnd={handleAnimationEnd}
            >
                <Icon className="event-icon" />
                <div className="event-text">
                    <span className="event-title">{title}</span>
                    <span className="event-desc">{desc}</span>
                </div>
            </div>
        </div>
    );
}

export default EventNotification;